import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { secureStorage } from '../shared/services/encryption/secureservice';
import { RegexService } from '../shared/form-validation/regex.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { RootService } from '../shared/services/root.service';
import { BehaviourSubjectService } from '../shared/services/behaviour-subject.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../shared/services/apiService.service';
import { SkeletonService } from '../shared/services/skeleton.service';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { isPlatformBrowser } from '@angular/common';
import { setImageUrl } from '../fni-modules/shared/helper/common_function';
import { CommonService } from '../shared/services/common.service';
import { FormErrorService } from '../shared/form-validation/form-error.service';
import { Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-finance-offers',
  templateUrl: './finance-offers.component.html',
  styleUrls: ['./finance-offers.component.scss'],
})
export class FinanceOffersComponent implements OnInit {
  districtList: any[];
  onEnquire() {
    throw new Error('Method not implemented.');
  }

  @ViewChild('successModal') successModal!: TemplateRef<any>;
  sub: Subscription = new Subscription();
  offersData: any = [];
  productLoaded: any = [];
  bannerList: any = [];
  environment1 = environment.s3bucket.url;
  maximumSize: any = 6;
  totalItemsOffers: any = 0;
  itemsPerPage: any = 10;
  currentPage: any = 1;
  userData: any;
  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,

    responsiveRefreshRate: 1000000,

    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
  };
  productDetailList: any;
  enquiryForm!: FormGroup;
  financerData = [
    { financier_name: 'Tata Motors Finance' },
    { financier_name: 'Cholamandalam' },
    { financier_name: ' Yes Bank' },
    { financier_name: 'SBI' },
    { financier_name: 'Sundaram Finance' },
    { financier_name: 'HDB Financial Services' },
    { financier_name: 'HDFC Bank' },
  ];
  disabledFields = false;
  encData = false;
  isSubmitted = false;
  isSuccess = false;
  stateList: any[];
  fieldDisable: boolean = false;

  financeForm: FormGroup;
  showOtpField = false;
  isOtpRequested = false;
  isOtpVerified = false;
  verificationMessage = '';
  private generatedOtp: string | null = null;
  buttonLabel = 'Get OTP';
  submitted = false;
  buttonEnabled = false;

  constructor(
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private apiService: ApiService,
    public skeletonService: SkeletonService,
    private toastrService: ToastrService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorage: secureStorage,
    private rootService: RootService,
    private behaviourSubject: BehaviourSubjectService,
    private fb: FormBuilder,
    private CommonService: CommonService,
    private regexService: RegexService,
    private formErrorService: FormErrorService,private meta: Meta

  ) {
    this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
  }

  ngOnInit(): void {
    this.currentPage = 1;
    this.userData = this.rootService.getUserData();
    this.getBannerList();
    this.sub.add(
      this.behaviourSubject.offerDeatil.subscribe((e) => {
        this.currentPage = e ? e : 1;
        this.pageChangeoffer(this.currentPage);
      })
    );

    this.financeForm = this.fb.group({
      firstName: ['', Validators.required,Validators.pattern(/^[a-zA-Z\s]*$/)],
      lastName: ['', Validators.required,Validators.pattern(/^[a-zA-Z\s]*$/)],
      pincode: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(6),
          Validators.pattern('^[1-9][0-9]{5}$'),
        ],
      ],
      state: ['', Validators.required],
      district: ['', Validators.required],
      mobileNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regexService.Phone),
        ],
      ],
      otp: ['',Validators.maxLength(6) ],
    });

    this.financeForm.get('mobileNumber')?.valueChanges.subscribe((newMobileNumber) => {
      if (this.isOtpVerified) {
        this.isOtpVerified = false;
        this.verificationMessage = '';
        this.buttonLabel = 'Get OTP';
        this.financeForm.get('otp')?.reset();
      }
    });

    this.financeForm.get('mobileNumber')?.valueChanges.subscribe((newMobileNumber) => {
      if (this.showOtpField) {
        this.showOtpField = false;
        this.buttonLabel = 'Get OTP';
        this.financeForm.get('otp')?.reset();
        this.verificationMessage = '';
        this.isOtpVerified = false;
      }
    });
  }

  get f() {
    return this.financeForm.controls;
  }

  handleButtonClick(): void {
    this.submitted = true;
    if (this.buttonLabel === 'Get OTP') {
      this.requestOtp();
    } else if (this.buttonLabel === 'Submit') {
      this.verifyOtp();
    }

  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  requestOtp() {
    const mobileNumber = this.financeForm.get('mobileNumber')?.value;

    if (!mobileNumber || mobileNumber?.length !== 10) {
      alert('Please enter a valid 10-digit mobile number.');
      return;
    }

    this.spinner.show();

    const payload = {
      mobile_number: mobileNumber,
      action_type: 'login',
    };

    this.sub.add(
      this.apiService.sentOtp1(payload).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.toastrService.success(res.data.msg);
            this.showOtpField = true;
            this.buttonLabel = 'Submit';
          } else {
            this.toastrService.warning('Something went wrong!');

          }
        },
        error: (error) => {},
        complete: () => {
          this.spinner.hide();
        },
      })
    );
  }

  checkOtpValue(event: any): void {

    if (event?.length === 6) {
      this.buttonEnabled = true;
    } else{
      this.buttonEnabled = false;

    }

    if (!this.isOtpVerified) {
      this.verificationMessage = '';
    }
  }

  verifyOtp() {
    const enteredOtp = this.financeForm.get('otp')?.value;
    const mobileNumber = this.financeForm.get('mobileNumber')?.value;

    this.spinner.show();

    const data = { mobile_number: mobileNumber, otp_number: enteredOtp };

    this.sub.add(
      this.apiService.verifyOtp(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.isOtpVerified = true;
            this.showOtpField = false;
            this.verificationMessage = 'OTP verified successfully!';
            if(res.data.msg === "User is not Registered!"){
              this.onSubmitFinanceOffers();
            }else{
              this.submitEnquiry();
            }
          } else {
            this.isOtpVerified = false;
            this.verificationMessage = 'Invalid OTP. Please try again.';
          }
        },
        error: (error) => {
          this.verificationMessage =
            'An error occurred while verifying OTP. Please try again.';
        },
        complete: () => {
          this.spinner.hide();
        },
      })
    );
  }
  onSubmitFinanceOffers() {
    if (this.financeForm.valid) {
      let data = {
        first_name: this.CommonService.replaceUnicode(
          this.financeForm.value.firstName
        ),
        last_name: this.CommonService.replaceUnicode(
          this.financeForm.value.lastName
        ),
        mobile_number: this.financeForm.value.mobileNumber,
        email_id: '',
        state: this.financeForm.value.state,
        district: this.financeForm.value.district,
      };

      this.sub.add(
        this.apiService.userSignup(data).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.isOfferSubmitted = true;
              this.submitEnquiry();
            }
          },
          error: (error) => {},
          complete: () => {
            this.spinner.hide();
          },
        })
      );
    }
  }

  getOfferDetails(reqBody: any) {
    try {
      let data
      if (isPlatformBrowser(this.platformId)) {
         data = localStorage.getItem('previousUrl');
      }
        let value = data?.split(',');
        let lob, ppl, pl, model;
        if (value) {
          lob = value[0];
          ppl = value[1];
          (pl = value[2]), (model = value[3]);
        }
        let val = {
          noOfCampaignOffers: 10,
          lob: lob ? lob : '',
          ppl: ppl ? ppl : '',
          pl: pl ? pl : '',
          state: this.userData.state ? this.userData.state : '',
          sortBy: 'campaignSchemePriority',
          sortOrder: 'asc',
          offset: reqBody.offset,
        };
        this.spinner.show();
        this.sub.add(
          this.apiService.getOffersDetailsNew(val).subscribe({
            next: (res: any) => {
              this.productLoaded = true;
              this.spinner.hide();
              this.totalItemsOffers = res.totalCount;
              res = res.offers;
              this.offersData = [];
              this.offersData = res;
            },
            error: () => {
              this.spinner.hide();
              this.productLoaded = true;
            },
            complete: () => {
              this.spinner.hide();
              this.productLoaded = true;
            },
          })
        );
      
    } catch (error) {
      this.spinner.hide();
      this.productLoaded = true;
    }
  }

  setFinancierImgUrl(financierId: any) {
    return setImageUrl(financierId);
  }

  async getBannerList() {
    let req = {
      page: 'FINANCE',
      offset: 0,
      size: 6,
    };

    await this.sub.add(
      this.apiService.getBannerListNew(req).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.spinner.hide();
            this.bannerList = response;
            return this.bannerList;
          } else {
            this.spinner.hide();
            this.bannerList = [];
            if (response?.data?.msg == 'User is not registered.') {
              this.toastrService.warning(response.data.msg || response.msg);
            } else {
              this.bannerList = [];

              this.spinner.hide();
            }
            return this.bannerList;
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');

          this.spinner.hide();
          return this.bannerList;
        },
        complete: () => {},
      })
    );
  }

  navigateToOfferDetail(data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (JSON.parse(this.localStorage.getItem('productOfferData'))) {
        this.productDetailList = JSON.parse(
          this.localStorage.getItem('productOfferData')
        );
        this.productDetailList.financierId = data.tmlSchemeID;
        this.productDetailList.financierName =
          data.financierDetails.crmFinancierName;
        this.localStorage.setItem(
          'productOfferData',
          JSON.stringify(this.productDetailList)
        );
        this.router.navigate(['offer-details'], {
          queryParams: {
            financierSchemeId: data.financierSchemeId,
            page: this.currentPage,
          },
        });
      } else {
        this.router.navigate(['offer-details'], {
          queryParams: {
            financierSchemeId: data.financierSchemeId,
            page: this.currentPage,
          },
        });
      }
    }
  }
  pageChangeoffer(page: any) {
    this.currentPage = page;
    page = page - 1;
    let reqBody = {
      offset: page,
    };
    this.getOfferDetails(reqBody);
  }
  GetTest(data: any) {
    
      let url;
      var dataUrl = data?.banner_link;
      if (dataUrl) {
        if (isPlatformBrowser(this.platformId)) {
        url = dataUrl?.replace(window.location.origin + '/' + dataUrl);
        }
        this.router.navigateByUrl(url);
      }
    
  }

  isOfferSubmitted: boolean = false;

  submitEnquiry(): void {
    const formData = this.financeForm.value;
    let data = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      mobile_number: formData.mobileNumber,
      is_active: true,
      state: formData.state,
      pincode: formData.pincode,
      district: formData.district
    };

    this.spinner.show();
    this.sub.add(
      this.apiService.addEnquireFinancerData(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.spinner.hide();
            this.openPopup();
            this.financeForm.reset();
            this.submitted = false;

            this.buttonLabel = 'Get OTP';
          } else {
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
            this.financeForm.reset();
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
        },
        complete: () => {
          this.spinner.hide();

        },
      })
    );
  }

  openPopup(): void {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'success-modal',
    };

    this.modalService.open(this.successModal, ngbModalOptions).result.then(
      (result) => {},
      (reason: any) => {}
    );
  }

  closePopup(): void {
    this.modalService.dismissAll();
    this.financeForm.reset();
    this.isSubmitted = false;
  }

  addressByPincode() {
    this.fieldDisable = false;
    if (this.financeForm.value.pincode?.length == 6) {
      this.getAddress(this.financeForm.value.pincode);
    }
  }

  getAddress(pincode: string | number) {
    const data = {
      pincode: pincode,
      app_name: 'com.tatamotors.cvonline',
      device_id: '1234',
    };
    this.fieldDisable = false;
    this.sub.add(
      this.apiService.getAddressByPincodeList(data).subscribe({
        next: (response: any) => {
          if (response?.length) {
            this.stateList = [response[0]?.state];
            this.districtList = [response[0]?.district];

            this.financeForm.patchValue({
              state: this.stateList[0]?.name || '',
              district: this.districtList[0] || '',
            });
            this.fieldDisable = false;
          } else {
            this.financeForm.patchValue({
              state: '',
              district: '',
            });
            this.fieldDisable = true;


            this.toastrService.warning(
              'Address not found for pincode provided.'
            );

          }
        },
        error: (err) => {
          // Log and handle errors here
          console.error('Error fetching address:', err);
          this.toastrService.warning(
            'Address not found for pincode provided.'
          );
        },
      })
    );
  }
  validateAlphabets(event: any) {
    event.target.value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  }
  sanitizeInput(input: string): string {
    // Remove HTML tags
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }

  // Usage in the HTML
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = this.sanitizeInput(inputElement.value);
  }
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.financeForm);

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
